import React from 'react';
import './Snowfall.css';

const Snowfall = () => {
  // Generate 35 snowflakes with randomized properties
  const snowflakes = Array.from({ length: 35 }, (_, i) => ({
    id: i,
    left: Math.random() * 100, // Random horizontal position (0-100%)
    animationDuration: 8 + Math.random() * 15, // 8-23 seconds
    animationDelay: Math.random() * 10, // 0-10 seconds delay
    size: 0.5 + Math.random() * 1.2, // Size multiplier
    opacity: 0.4 + Math.random() * 0.6, // 0.4-1.0
  }));

  return (
    <div className="snowfall-container">
      {snowflakes.map((flake) => (
        <div
          key={flake.id}
          className="snowflake"
          style={{
            left: `${flake.left}%`,
            animationDuration: `${flake.animationDuration}s`,
            animationDelay: `${flake.animationDelay}s`,
            transform: `scale(${flake.size})`,
            opacity: flake.opacity,
          }}
        >
          ❄
        </div>
      ))}
    </div>
  );
};

export default Snowfall;
